export default "__VITE_ASSET__4d5cc13e__"